import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Button from "sushiweb/Button";
import * as TdsAndRiderPayoutJobsAction from "../../store/actions/TdsAndRiderPayoutJobs";
import Permission from "../../components/Common/Permission";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import JobsOptionModal from "../../components/TdsAndRiderPayoutJobs/JobsOptionsModal";
import TdsAndRiderPayoutJobsList from "../../components/TdsAndRiderPayoutJobs/JobsList";

const TdsAndRiderPayoutJobs = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [actionName, setActionName] = useState("");
  const [activeJobType, setActiveJobType] = useState("tds_deduction");
  const allActions = MenuActionsMappings[MenuNames.TDS_AND_RIDER_PAYOUT_JOBS];

  const handleButtonClick = (actionName) => {
    setShowModal(true);
    setActionName(actionName);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleModalSubmit = (jobType) => {
    if (actionName === "get") {
      props.getJobsList(jobType);
      setActiveJobType(jobType);
    } else if (actionName === "trigger") {
      let payloadJobType = "rider_weekly_payout";
      if (jobType === "tds_deduction") {
        payloadJobType = "tds_deduction_calculation";
      }

      const payload = { job_name: payloadJobType };
      props.triggerJob(payload);
    }
    handleModalClose();
  };

  return (
    <div className="TDS-And-Rider-Payout-Jobs-View container">
      <div
        style={{ maxWidth: "320px" }}
        className="actionBar mb-20 flex items-center justify-end"
      >
        <Permission requiredPerms={[allActions.LIST]}>
          <Button
            onClick={() => handleButtonClick("get")}
            className="sushi-btn ml-16"
          >
            Get Jobs
          </Button>
        </Permission>
        <Permission requiredPerms={[allActions.TRIGGER_JOBS]}>
          <Button
            onClick={() => handleButtonClick("trigger")}
            className="sushi-btn ml-16"
          >
            Trigger A Job
          </Button>
        </Permission>
      </div>
      {showModal && (
        <JobsOptionModal
          handleModalClose={handleModalClose}
          handleModalSubmit={handleModalSubmit}
          activeJobType={activeJobType}
        />
      )}
      <Permission requiredPerms={[allActions.LIST]}>
        <TdsAndRiderPayoutJobsList
          jobs={props.jobsList}
          activeJobType={activeJobType}
        />
      </Permission>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { TdsAndRiderPayoutJobs } = state;
  return {
    jobsList: TdsAndRiderPayoutJobs.jobs,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getJobsList: bindActionCreators(
      TdsAndRiderPayoutJobsAction.getJobsList,
      dispatch
    ),
    triggerJob: bindActionCreators(
      TdsAndRiderPayoutJobsAction.triggerJob,
      dispatch
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TdsAndRiderPayoutJobs);
